import * as yup from 'yup';
import {
  email,
  name,
  phone,
  password,
  amount,
  reason,
  participant,
  planCost,
  planDuration,
  planName,
  planType,
  maxDuration,
  billNumber,
  date,
  timeDuration,
} from './validationSchema';

export const loginValidation = yup.object({
  email: email,
  password: password,
});
export const refundModalValidation = yup.object({
  amount: amount,
  reason: reason,
});
export const addPlanValidation = yup.object({
  planName: planName,
  planType: planType,
  planDuration: planDuration,
  planCost: planCost,
  participant: participant,
  maxDuration: maxDuration,
  timeDuration: timeDuration,
  // features: features,
});

export const userListEditModal = yup.object({
  name: name,
  phone: phone,
});

export const memberListEditModal = yup.object({
  name: name,
  phone: phone,
});

export const paymentFilter = yup.object({
  name: name,
  email: email,
  billNumber: billNumber,
  date: date,
});

export const featuresEditModal = yup.object({
  name: name,
});

export const featuresAddModal = yup.object({
  name: name,
});
